function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("mask", {
  id: "mask0",
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 90,
  height: 60
}, /*#__PURE__*/React.createElement("rect", {
  width: 90,
  height: 60,
  fill: "black"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 90,
  height: 60,
  fill: "#151E2C"
}), /*#__PURE__*/React.createElement("path", {
  d: "M59.5137 17.4494L54.675 19.9147L31.3094 31.816C31.2304 31.2134 31.1906 30.6062 31.1904 29.9985C31.1936 27.5735 31.8302 25.1914 33.0373 23.0882C34.2444 20.985 35.98 19.2336 38.0722 18.0075C40.1644 16.7815 42.5406 16.1233 44.9655 16.0982C47.3903 16.073 49.7797 16.6818 51.8969 17.8643L54.6665 16.4531L55.0796 16.2423C52.5425 14.4008 49.5456 13.2967 46.4202 13.0519C43.2948 12.8071 40.1626 13.4313 37.3697 14.8553C34.5768 16.2794 32.2321 18.4479 30.5946 21.1212C28.9571 23.7946 28.0906 26.8686 28.0909 30.0036C28.0909 30.4366 28.1074 30.8678 28.1402 31.2974C28.1863 31.9058 28.0514 32.5141 27.7525 33.046C27.4536 33.5778 27.004 34.0094 26.4605 34.2863L25 35.031V38.5045L29.2998 36.3129L30.6922 35.6023L32.0643 34.9035L56.6965 22.3528L59.4644 20.9433L65.1855 18.0275V14.5557L59.5137 17.4494Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M65.1855 21.5029L33.4635 37.6546L30.6956 39.0675L25 41.9697V45.4398L30.6565 42.558L35.4952 40.0927L58.8846 28.1744C58.9637 28.781 59.0034 29.3921 59.0036 30.0038C59.0021 32.4316 58.3656 34.8168 57.1574 36.9226C55.9491 39.0283 54.2111 40.7815 52.1159 42.0079C50.0206 43.2344 47.6411 43.8915 45.2134 43.914C42.7857 43.9365 40.3943 43.3237 38.2767 42.1363L38.1067 42.2264L35.1042 43.7566C37.6407 45.5981 40.637 46.7026 43.7619 46.948C46.8868 47.1933 50.0187 46.57 52.8116 45.1469C55.6045 43.7238 57.9496 41.5564 59.5878 38.884C61.226 36.2116 62.0935 33.1384 62.0946 30.0038C62.0946 29.5669 62.0775 29.1299 62.0452 28.6981C61.9993 28.09 62.134 27.4818 62.4326 26.95C62.7312 26.4183 63.1802 25.9866 63.7233 25.7092L65.1855 24.9645V21.5029Z",
  fill: "white"
}));

var SvgXlm = function SvgXlm(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 60,
    viewBox: "0 0 90 60",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgXlm, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/XLM.e7f1d14f.svg";
export { ForwardRef as ReactComponent };